import React from 'react'

export default function LocationBanner() {
  return (
    <>
      <section className="branch-location">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
              <div className="location-text">
                <h1 className="heading">Serving You Across Multiple Locations</h1>
                <p>With a growing presence across multiple locations, Doxandbox is committed to delivering reliable and efficient solutions wherever your business operates. Our network ensures seamless support, accessibility, and consistent service to meet your needs.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  )
}
